parsedValue